import React, { Component, Fragment } from 'react';
import api from '../../services/api';
import { Link } from "react-router-dom";
import './styles.css';

class Company extends Component {

    state = {
        load: false,
        companyContacts: {}
    }

    async componentDidMount() {
        await this.searchContactsCompany();
    }

    searchContactsCompany = async () => {
        const companyContacts = await api.get(`/companies/${localStorage.getItem('CompanyId')}/contacts`);
        this.setState({ companyContacts: companyContacts.data.rows });
    }

    render() {
        return (
            <Fragment>
                <div className="row page-titles">
                    <div className="col-md-5 col-8 align-self-center">
                        <h3 className="text-themecolor">Contatos
                        {(this.state.load) ? <i className="fa fa-spin fa-spinner"></i> : null}
                        </h3>
                    </div>
                </div>
                <form action="javascript:void(0)" id="formDocuments">
                    <div className="row alert alert-primary">
                        <span>
                            Estes são os contatos que acessam o sistema.
                        </span>
                    </div>
                    <div className="row card">
                        <div className="col-md-12">
                            <div className="card-body">
                                <ul className="feeds">
                                    {
                                    (this.state.companyContacts.length) ?
                                            this.state.companyContacts.map((item) => {
                                                return (
                                                  <li key={item.id}>
                                                    <div className="bg-light-primary">
                                                      <i className="fa fa-user-o text-primary"></i>
                                                    </div>
                                                    <label>{item.name}</label> -
                                                    <i
                                                      className="label label-light-primary"
                                                      id="1"
                                                    >
                                                      {item.email}
                                                    </i>
                                                    <Link
                                                      to={`/contact-edit/${item.id}/${localStorage.getItem("CompanyId")}`}
                                                      id={item.id}
                                                      title={item.name}
                                                      className="btn btn-rounded btn-outline-info"
                                                    >
                                                      <i className="fa fa-edit" />
                                                    </Link>
                                                  </li>
                                                );
                                            })
                                            : null
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </form>
            </Fragment >
        )
    }

}

export default Company;